export const GET_UNAVAILABLE_TUTOR_REQUEST='unAvailableTutorReducer/GET_UNAVAILABLE_TUTOR_REQUEST';
export const GET_UNAVAILABLE_TUTOR_SUCCESS='unAvailableTutorReducer/GET_UNAVAILABLE_TUTOR_SUCCESS';
export const GET_UNAVAILABLE_TUTOR_FAILED='unAvailableTutorReducer/GET_UNAVAILABLE_TUTOR_FAILED';